import React from 'react'
import ReactDOM from 'react-dom'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import TagManager from 'react-gtm-module'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { themes } from './utils/themes'

// Google Tag Manager Setup
const tagManagerArgs = {
  gtmId: 'GTM-5ZRV4QK'
}

TagManager.initialize(tagManagerArgs)

const appTheme = createMuiTheme(themes)

ReactDOM.render(
  <ThemeProvider theme={appTheme}>
    <App />
  </ThemeProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
